// Loader.js
import React from "react";
import Spinner from "react-bootstrap/Spinner";
import "./../css/loader.css"; // Create this CSS file to style your loader if needed

const Loader = () => {
  return (
    <div className="loader-container">
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};

export default Loader;
